import React from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import MaintenanceFleetReportStore from "../store/MaintenanceFleetReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import withRouter from "../withRouter";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    // console.log(val.title.length)
  });

  return arr;
};
const { Option } = Select;
class MaintenanceFleetReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.maintenanceFleetReportStore = new MaintenanceFleetReportStore();
    this.vehicleStore = new VehicleStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectAllVehicles: false,
      selectAllServices: false,
      selectedServices: [],
      companyId: "",
      loadData: 0,
      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notasset: false,
      selectedColumns: widthAdderFunc([
        {
          // title: "Vehicle No ",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          ellipsis: {
            showTitle: true,
          },
          // fixed: "left",
          // width:'15%'
        },
        {
          // title: "Vehicle Type",
          title: context.translate("_VEHICLE_TYPE_"),
          dataIndex: "type",
          key: "Vehicle Type",
          ellipsis: {
            showTitle: true,
          },
          // fixed: "left",
          // width:'15%'
        },

        {
          // title: "Driver Name",
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
          ),
          dataIndex: "driverName",
          key: "driverName",
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: "Current Odometer Value",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_CURRENTODOMETER_"
          ),
          dataIndex: "distance",
          key: "CurrentOdometerValue",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Service Type",
          title: context.translate("_SERVICE_TYPE_"),
          dataIndex: "serviceName",
          key: "serviceName",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Service Date",
          title: context.translate("_SERVICE_DATE_"),
          dataIndex: "serviceDate",
          key: "serviceDate",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Odometer",
          title: context.translate("_FLEET_DASHBORD_SETTING_ODOMETER_"),
          dataIndex: "currentOdometer",
          key: "currentOdometer",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "  Garage Name",
          title: context.translate("_GARAGE_NAME_"),
          dataIndex: "garageName",
          key: "garageName",
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: "Garage Address  ",
          title: context.translate("_GARAGE_ADDRESS_"),
          dataIndex: "garageAddress",
          key: "garageAddress",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: " Extra Works Done",
          title: context.translate("_EXTRA_WORK_DONE_"),
          dataIndex: "extraWorksDone",
          key: "extraWorksDone",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: " Amount ",
          title: context.translate("_AMOUNT_"),
          dataIndex: "totalAmmount",
          key: "totalAmmount",
          ellipsis: {
            showTitle: true,
          }, // fixed: 'right',
        },
        {
          // title: "Last Oil Change(Date/Time and Odometer)  ",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_LASTOILCHANGE_"
          ),
          dataIndex: "lastOilDate",
          key: "lastOilDate",
          ellipsis: {
            showTitle: true,
          },
          // fixed: 'right',
        },
        {
          // title: "Last Tyre Change(Date/Time and Odometer)  ",
          title: context.translate("_LAST_TYRE_CHANGE_"),
          dataIndex: "lastTireDate",
          key: "lastTireDate",
          ellipsis: {
            showTitle: true,
          },
          //fixed: 'right',
        },
        {
          // title: "Last Major Service(Date/Time and Odometer)  ",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_LASTMAJORSERVICE_"
          ),
          dataIndex: "lastServiceDate",
          key: "lastServiceDate",
          ellipsis: {
            showTitle: true,
          },
          // fixed: 'right',
        },
        {
          // title: "Next Oil Change (Km) ",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_NEXTOILCHANGE_"
          ),
          dataIndex: "nextOil",
          key: "Next Oil Change",
          ellipsis: {
            showTitle: true,
          },
          // fixed: 'right',
        },
        {
          // title: "Next Tyre Change (Km) ",
          title: context.translate("_NEXT_TYRE_CHANGE_KM_"),
          dataIndex: "nextTire",
          key: "Next Tire Change",
          ellipsis: {
            showTitle: true,
          },
          // fixed: 'right',
        },
        {
          // title: "Next Major Service Change(Km)  ",
          title: context.translate(
            "_FLEET_REPORTS_MAINTENANCEREPORT_NEXTMAJORSERVICE_"
          ),
          dataIndex: "nextService",
          key: "Next Major Service",
          ellipsis: {
            showTitle: true,
          },
          // fixed: 'right',
        },
      ]),
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        // console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            sid: this.state.selectedServices,
            serviceId: this.state.selectedServices,
          };
          if (val.key == "excel") {
            // console.log("afd")
            this.maintenanceFleetReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.maintenanceFleetReportStore.exportpdf(getData);
          }
          // if (val.key == "csv") {
          //   this.maintenanceFleetReportStore.exportcsv(getData);
          // }
          // if (val.key == "xml") {
          //   this.maintenanceFleetReportStore.exportxml(getData);
          // }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  async componentDidMount() {
    await this.setState({ column: this.state.selectedColumns });
    // await this.maintenanceFleetReportStore.loadData({ offset: 0, limit: 50 });

    await this.maintenanceFleetReportStore.getServiceData();

    this.setState({ pageSize: 50 });

    await this.setState({ column: this.state.selectedColumns });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({
      selectAllVehicles: false,
    });

    await this.handleAllSelectVehicles();
    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    // console.log(this.vehicleStore.getVehiclesUsingCompanyId);
    await this.setState({ loadData: 1 });
    // await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    this.setState({ Notasset: false });
    // await this.maintenanceFleetReportStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    // });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    // console.log(pagination);
    // await this.setState({
    //   currentPage: pagination.current,
    //   pageSize: pagination.pageSize,
    // });
    // this.handleSearch();
    await this.setState({
      // currentPage: pagination.current,
      currentPage: pagination.current,

      pageSize: pagination.pageSize,

      // pageNo: pagination?.current ? pagination?.current : this.state.pageNo,
      // pageSize: pagination?.pageSize ? pagination?.pageSize : this.state.pageSize,
    });
    await this.showData();
  }

  // vehicleSelect = async (val) => {
  //   console.log(val);
  //   await this.setState({ selectedVehicles: val });
  // };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      await this.maintenanceFleetReportStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.selectedVehicles,
        serviceId: this.state.selectedServices,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      });

      await this.setState({ loadData: 1 });
    }
  };

  handleCheckboxChange = async (column) => {

    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      // console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleSelectAllServices = async (e) => {
    if (this.state.selectAllServices) {
      const allServices =
        this.maintenanceFleetReportStore?.maintenanceService.map((val) => {
          return val.serviceId;
        });
      await this.setState({ selectedServices: allServices });
    } else {
      await this.setState({ selectedServices: [] });
    }
  };

  render() {
    const companyInputStyle = this.state.Notcompany
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate(
                  "_FLEET_REPORTS_MAINTENANCEREPORT_TITLE_"
                )}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.maintenanceFleetReportStore?.maintenanceReportStore
                      ?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                    //  style={{backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    // console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      // console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <Checkbox
                  checked={this.state.selectAllServices}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllServices: e.target.checked,
                    });
                    // console.log(e.target.checked);
                    await this.handleSelectAllServices();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}
                <Select
                  className="searchInput"
                  mode="multiple"
                  maxTagCount="responsive"
                  value={this.state.selectedServices}
                  onChange={(val) => {
                    this.setState({ selectedServices: val });
                    if (
                      this.maintenanceFleetReportStore?.maintenanceService
                        .length > val.length
                    ) {
                      this.setState({ selectAllServices: false });
                    } else {
                      this.setState({ selectAllServices: true });
                    }
                  }}
                  onSearch={this.handleSearch}
                  // onChange={(val) => this.vehicleSelect(val)}
                  fieldNames={{ label: "serviceName", value: "serviceId" }}
                  // placeholder="Service Type"
                  placeholder={this.context.translate("_SERVICE_TYPE_")}
                  optionFilterProp="children"
                  options={this.maintenanceFleetReportStore?.maintenanceService}
                  style={{ width: 160 }}
                />
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.maintenanceFleetReportStore?.maintenanceReportStore
                      .length > 0
                      ? false
                      : true
                    // this.mileageReportStore?.mileageReportStore?.length > 0 ? false : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={400}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {/* {console.log(this.newColumns, "Df")} */}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.maintenanceFleetReportStore.pageSize}
            total={this.maintenanceFleetReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={
              this.maintenanceFleetReportStore?.maintenanceReportStore
            }
            loading={this.maintenanceFleetReportStore?.loading}
            onChange={this.handleTableChange}
            size="middle"
            scroll={{
              x: "calc(700px + 50%)",
              y: 280,
            }}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />
        </div>
      </>
    );
  }
}
MaintenanceFleetReportList.contextType = StoreContext;
export default observer(withRouter(MaintenanceFleetReportList));
